import './S_ClampLines.scss';
import { observer } from 'mobx-react-lite';
import { createElement, MouseEvent, ReactElement } from 'react';

interface S_ClampLinesProps {
  text: string;
  id?: string;
  innerElement?: string;
  lines?: number;
  onClick?: (e: MouseEvent<HTMLDivElement>) => void;
}

export const S_ClampLines = observer(
  (props: S_ClampLinesProps): ReactElement => (
    <div
      id={props.id}
      className='s-clamp-lines'
      title={props.text}
      onClick={props.onClick}
      css={{
        '--line-clamp-count': props.lines ?? 1,
      }}
    >
      {createElement(props.innerElement || 'div', null, props.text)}
    </div>
  )
);
